export const ALGOLIA_USER_TOKEN_KEY = 'konfetti-algolia-tracking-user-token'
export const HITS_PER_SHOWCASE = 8
export const HITS_PER_PAGINATION = 22
